<template>
	<div class="watch-options-configs">
		<spinner v-if="configs.loading"/>
		<form v-else @submit.prevent="validateAndSubmit">
			<div class="idi-table configs">
				<div class="idi-header">
					<div class="idi-cell">{{ $t('labels.general.name') }}</div>
					<div class="idi-cell">{{ $t('labels.general.value') }}</div>
				</div>
				<!-- <div class="idi-row" v-for="(config, index) in configs.data" :key="config.name">
					<div class="idi-cell">{{ translate(config.name) }}</div>
					<div class="idi-cell">
						<input type="checkbox" v-if="typeField(config.name) == 'bool'" v-model="configs.data[index].value" :name="`configs_${config.name}`" :true-value="'true'" :false-value="'false'" />
						<input-text v-else v-model="configs.data[index].value" :name="`configs_${config.name}`" rules="required"/>
					</div>
				</div> -->
				<div class="idi-row" v-for="config in getConfigs2()" :key="config.key">
					<div class="idi-cell">{{ $t(config.name) }}</div>
					<div class="idi-cell">
						<input type="checkbox" v-if="typeField(config.key) == 'bool'" v-model="config.value" :name="`configs_${config.key}`" :true-value="'true'" :false-value="'false'" />
						<input-text v-else v-model="config.value" :name="`configs_${config.key}`" rules="required"/>
					</div>
				</div>
			</div>
			<div class="form-group-actions">
				<button-submit-icon-text :class="{disabled: !hasChanges}" :loading="form.loading" icon="save">{{ $t('buttons.general.save') }}</button-submit-icon-text>
			</div>
		</form>
	</div>
</template>

<script>
//import { debounce } from 'debounce'
import ApiCollection from '@/classes/api/ApiCollection'
import FormObject from '@/classes/api/FormObject'
export default {
	props: [
		'user_uid',
		'watch_id'
	],
	data () {
		return {
			configs2: [
				{ key: "timezone", name: this.$t("Timezone"), value: "UTC+0h", help: this.$t("") },
				{ key: "sample_record", name: this.$t("Sample Record"), value: "60", help: this.$t("") },
				{ key: "sync_normal", name: this.$t("Sync Normal"), value: "300", help: this.$t("") },
				{ key: "sos_phone", name: this.$t("SOS Phone"), value: "112", help: this.$t("") },
				{ key: "offline_timer", name: this.$t("Offline Timer"), value: "360", help: this.$t("") },
				{ key: "fall_detection", name: this.$t("Fall Detection"), value: "true", help: this.$t("") },
				{ key: "reference_systolic", name: this.$t("Reference Systolic"), value: "110", help: this.$t("") },
				{ key: "reference_diastolic", name: this.$t("Reference Diastolic"), value: "70", help: this.$t("") },
				{ key: "heart_rate_min", name: this.$t("Heart Rate Min"), value: "50", help: this.$t("") },
				{ key: "heart_rate_max", name: this.$t("Heart Rate Max"), value: "170", help: this.$t("") },
			],
			name: 'watch options configs',
			configs: new ApiCollection(),
			form: new FormObject(),
			configsDataClone: {},
			savingConfigs: new Set(),
			savingConfigsTrigger: 0
		}
	},
	computed: {
		hasChanges() {
			return !this.configs2.reduce((accumulator, currentValue) => {
				if (!this.configsDataClone.hasOwnProperty(currentValue.key)) {
					return accumulator
				}
				return accumulator && this.configsDataClone[currentValue.key].value === currentValue.value
			}, true)
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll()
				.then(result => {
					if (result) this.editConfigs()
				})
		},
		parseData(response) {
			const data = response.body.reduce((acc, val) => { acc[val.name] = val; return acc }, {})

			this.configs2.forEach(el => {
				if (data.hasOwnProperty(el.key))
					el.value = data[el.key].value
			});

			this.configsDataClone = JSON.parse(JSON.stringify(this.configs2)).reduce((acc, val) => { acc[val.key] = val; return acc }, {})
		},
		getConfigs2 () {
			return this.configs2;
		},
		getConfigs () {
			this.configs.loading = true
			this.$api.patients.configurations.get(this, this.user_uid, this.watch_id)
				.then(response => {
					this.$log.info(this.name, 'patients.configurations.getAll OK', response)()
					this.parseData(response)
				}).catch(error => {
					this.$log.error(this.name, 'patients.configurations.getAll ERROR', error)()
					this.configs.error = error
				}).finally(() => {
					this.configs.loading = false
				})
		},
		editConfigs () {
			const data = this.configs2
				.map(el => {
					return { key: el.key, value: el.value }
				}).filter(el => {
					if (!this.configsDataClone.hasOwnProperty(el.key)) {
						return true
					}
					return this.configsDataClone[el.key].value !== el.value
				})

			this.form.loading = true
			this.$api.patients.configurations.save(this, this.user_uid, this.watch_id, { changes: data })
				.then(response => {
					this.$log.info(this.name, 'patients.configurations.edit OK', response)()
					this.parseData(response)
				}).catch(error => {
					this.$log.error(this.name, 'patients.configurations.edit ERROR', error)()
				}).finally(() => {
					this.form.loading = false
				})
		},
		typeField (fieldName) {
			if (['fall_detection'].includes(fieldName)) {
				return 'bool'
			}
			return 'string'
		}
	},
	mounted () {
		this.getConfigs()
	}
}
</script>

<style scoped>
.disabled {
	opacity: 0.5;
	pointer-events: none;
}
</style>


// WEBPACK FOOTER //
// src/components/watch/options/WatchOptionsConfigs.vue